import sanitizeHtml from 'sanitize-html';

const sanitizeHTML = (htmlContent: string) => {
  if (htmlContent?.includes('<a')) {
    htmlContent = htmlContent.replace(/<a\s([^>]*)>/gi, (match, attributes) => {
      const hrefMatch = attributes.match(/href\s*=\s*["']([^"']*)["']/i);
      const isInternalLink = hrefMatch?.[1].includes('collegehai.com/');

      if (isInternalLink) {
        if (/rel\s*=\s*["'][^"']*["']/i.test(attributes)) {
          return match.replace(/rel\s*=\s*["']([^"']*)["']/i, 'rel="dofollow"');
        }
        return `<a ${attributes} rel="dofollow">`;
      }

      if (/rel\s*=\s*["'][^"']*["']/i.test(attributes)) {
        if (!/nofollow/i.test(attributes)) {
          return match.replace(/rel\s*=\s*["']([^"']*)["']/i, (_, relValue) => {
            return `rel="${relValue} nofollow"`;
          });
        }
        return match;
      }
      return `<a ${attributes} rel="nofollow">`;
    });
  }

  if (htmlContent?.includes(`<figure class="table"`)) {
    htmlContent = htmlContent.replace(/<figure\s+class=["']table["']>(.*?)<\/figure>/gis, (match, innerContent) => {
      if (innerContent.includes('ck-table-resized')) {
        const colMatch = innerContent.match(/<colgroup>.*?<\/colgroup>/is);
        if (colMatch) {
          const colCount = (colMatch[0].match(/<col/g) || []).length;
          if (colCount > 4) {
            return `<figure class="table table-scroll">${innerContent.replace(
              'ck-table-resized',
              'ck-table-resized ck-table-resized-scroll',
            )}</figure>`;
          }
        }
      }
      return match;
    });
  }

  if (!htmlContent?.includes('<oembed')) {
    return htmlContent;
  }

  const sanitizedContent = sanitizeHtml(htmlContent, {
    allowedTags: [
      ...sanitizeHtml.defaults.allowedTags,
      'img',
      'iframe',
      'oembed',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td',
      'span',
      'ul',
      'ol',
      'li',
      'div',
      'p',
      'figure',
      'figcaption',
      'a',
    ],
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'],
      oembed: ['url'],
      img: ['src', 'alt', 'width', 'height', 'style', 'srcset', 'sizes'],
      table: ['class', 'style'],
      thead: ['class', 'style'],
      tbody: ['class', 'style'],
      tr: ['class', 'style'],
      th: ['class', 'style'],
      td: ['class', 'style'],
      span: ['class', 'style'],
      ul: ['class', 'style'],
      ol: ['class', 'style'],
      li: ['class', 'style'],
      div: ['class', 'style'],
      p: ['class', 'style'],
      figure: ['class', 'style'],
      figcaption: ['class', 'style'],
    },
    allowedStyles: {
      '*': {
        color: [/^#[0-9a-fA-F]{3,6}$/, /^rgb\((\d{1,3},\s*){2}\d{1,3}\)$/, /^rgba\((\d{1,3},\s*){3}[\d.]+\)$/],
        'background-color': [
          /^#[0-9a-fA-F]{3,6}$/,
          /^rgb\((\d{1,3},\s*){2}\d{1,3}\)$/,
          /^rgba\((\d{1,3},\s*){3}[\d.]+\)$/,
        ],
        'font-size': [/^\d+(?:px|em|%)$/],
        'font-family': [/^[\w\s,"-]+$/],
        'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
        'list-style-type': [/^disc$/, /^circle$/, /^square$/, /^decimal$/, /^lower-roman$/, /^upper-roman$/],
        'list-style-position': [/^inside$/, /^outside$/],
        'margin-left': [/^\d+(?:pt|px|em|%)$/],
        width: [/^\d+(?:pt|px|em|%)$/],
        'aspect-ratio': [/^\d+\/\d+$/],
      },
    },
    allowedClasses: {
      '*': ['*'],
    },
  });

  const convertedContent = sanitizedContent.replace(/<oembed url="(.+?)"><\/oembed>/g, (match, url) => {
    let embedUrl = url;

    if (url.includes('youtu.be') || url.includes('youtube.com')) {
      const youtubeId = url.split('v=')[1] || url.split('youtu.be/')[1] || url.split('/embed/')[1];
      embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
    } else if (url.includes('vimeo.com')) {
      const vimeoId = url.split('.com/')[1];
      embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
    }

    return `<iframe width="100%" height="360" src="${embedUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  });

  return convertedContent;
};

export default sanitizeHTML;
